export const holidays = {
  "Cinco de Mayo": {
    file: "CincoDeMayo2.jpg",
  },
  Christmas: {
    file: "holidays/Christmas.png",
  },
  Easter: {
    file: "holidays/Easter.png",
  },
  "Family Night": {
    file: "FamilyNight-heart.jpg",
  },
  "Father's Day": {
    file: "Calyx_Hypersign-graphics-FathersDay.jpg",
  },
  "Flag Day": {
    file: "Calyx_Hypersign-graphics-FlagDay.jpg",
  },
  "Grand Opening!": {
    file: "grand-opening.jpg",
    className: "month-image__image--large",
  },
  Halloween: {
    file: "holidays/Halloween.png",
  },
  Hanukkah: {
    file: "holidays/Hanuhkkah.png",
  },
  "Independence Day": {
    file: "",
  },
  "Labor Day": {
    file: "holidays/Labor Day.png",
  },
  "MLK Day": {
    file: "holidays/MLK Day.png",
  },
  "Memorial Day": {
    file: "Calyx_Hypersign-graphics-MemorialDay.jpg",
  },
  "Mother's Day": {
    file: "Calyx_Hypersign-graphics-MothersDay.jpg",
  },
  "New Years Day": {
    file: "holidays/New Years.png",
  },
  "New Years Eve": {
    file: "holidays/NYE.png",
  },
  "St. Patrick's Day": {
    file: "holidays/St Patricks Day.png",
  },
  "Summer Begins": {
    file: "Calyx_Hypersign-graphics-SummerBegins.jpg",
  },
  Thanksgiving: {
    file: "holidays/Thanksgiving 2.png",
  },
  "Valentine's Day": {
    file: "holidays/Valentines Day.png",
  },
  Veterans: {
    file: "holidays/Veterans Day.png",
  },
};
